import { render, staticRenderFns } from "./TopWordsDashboardItem.vue?vue&type=template&id=5c386309&scoped=true"
import script from "./TopWordsDashboardItem.vue?vue&type=script&lang=js"
export * from "./TopWordsDashboardItem.vue?vue&type=script&lang=js"
import style0 from "./TopWordsDashboardItem.vue?vue&type=style&index=0&id=5c386309&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c386309",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/admin-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5c386309')) {
      api.createRecord('5c386309', component.options)
    } else {
      api.reload('5c386309', component.options)
    }
    module.hot.accept("./TopWordsDashboardItem.vue?vue&type=template&id=5c386309&scoped=true", function () {
      api.rerender('5c386309', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Dashboard/Items/TopWordsDashboardItem.vue"
export default component.exports